namespace Pages {
    export class CustomersPage {
        private readonly _repository: RavenDbClient;

        constructor(repository: RavenDbClient) {
            this._repository = repository;
        }
        async index() {
            return new PageViewResult("Customers/", {});
        }
        async add() {
            return new PageViewResult("Customers/add/", {
                model: new Entities.Customer({
                    companyName: "",
                    firstName: "",
                    lastName: "",
                    invoiceAddress: {},
                    shippingAddress: {}
                }),
                invoiceAsShippingAddress: true
            } as Models.CustomerModel);
        }
        async insert({ model }: { model: Models.CustomerModel }) {
            if (model.invoiceAsShippingAddress)
                model.model.shippingAddress = model.model.invoiceAddress;

            await this._repository.saveDocument(model.model);
            return new PageActionResult(
                new PageActionBack(new PageActionEvent("customerChanged"))
            );
        }
        async edit({ id }: { id: string }) {
            const {document: model} = await this._repository.getDocument<Entities.Customer>(id);
            return new PageViewResult("Customers/edit/", {
                model: model,
                invoiceAsShippingAddress: false
            } as Models.CustomerModel);
        }

        async update({ id, model }: { id: string, model: Models.CustomerModel }) {
            if (model.invoiceAsShippingAddress)
                model.model.shippingAddress = model.model.invoiceAddress;

            await this._repository.saveDocument(model.model);
            return new PageActionResult(
                new PageActionBack(new PageActionEvent("customerChanged"))
            );
        }

        async delete({ id, model }: {id: string, model: Models.CustomerModel}) {
            await this._repository.deleteDocument(model.model.id);
            return new PageActionResult(
                new PageActionBack(new PageActionEvent("customerChanged"))
            );
        }

    }
}